import React, { FC } from 'react';
import { Card, Col, Container, Image, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import PageTitle from '../../components/layout/pageTitle/PageTitle';
import SubmissionsChart from './components/charts/submissions/SubmissionsChart';

const Dashboard: FC = () => {
  const intl = useIntl();
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageTitle title={intl.formatMessage({ id: 'navbar.dashboard.title' })}></PageTitle>
          <Row>
            <Col xl={4}>
              <Card className="overflow-hidden">
                <Card.Img variant="top" src="holder.js/100px180?text=Image cap" />
                <Card.Body>
                  <Row>
                    <Col xl={4}>
                      <div className="avatar-md">
                        <Image
                          src="https://lh3.googleusercontent.com/ogw/ADGmqu_MOjCASKou-YXMYpZNv1cLTybAlGUN1gsp-500Ww=s32-c-mo"
                          thumbnail
                          roundedCircle
                        />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col xl={8}>
              <Row>
                <Col md={4}>
                  <Card>
                    <Card.Body>
                      <div className="media">
                        <div className="media-body">
                          <p className="text-muted fw-medium">Submissions</p>
                          <h4 className="mb-0">1,235</h4>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card>
                    <Card.Body>
                      <div className="media">
                        <div className="media-body">
                          <p className="text-muted fw-medium">Revenues</p>
                          <h4 className="mb-0">$35,723</h4>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card>
                    <Card.Body>1</Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Card>
                    <Card.Body>
                      <div className="media">
                        <div className="submission-count-chart media-body">
                          <p className="text-muted fw-medium">Submission Count</p>
                          <SubmissionsChart></SubmissionsChart>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <Card.Body>
                  <Card.Title>Latest Transaction</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
